import { getLastLegTracking } from '@savgroup-front-common/core/helpers/getLastLegTracking';
import { CustomerFileSummary } from '@savgroup-front-common/types';

interface UseTrackingInfoArgs {
  fileInfo: CustomerFileSummary;
}

interface UseTrackingInfoReturnValue {
  trackingNumber?: string;
  trackingUrl?: string;
  hasTrackingNumber: boolean;
  hasTrackingUrl: boolean;
}

export const useTrackingInfo = ({
  fileInfo,
}: UseTrackingInfoArgs): UseTrackingInfoReturnValue => {
  return getLastLegTracking(fileInfo.trackingNumbers);
};
